export enum StatusCreateEnum {
  active = 'active',
  // error = 'error',
  inactive = 'inactive',
}